export function createPreferences() {
  return {
    version: 1,
    data: {
      freeCameraInvertRotation: false,
      autosaveEnabled: true,
    },
  };
}
